import adwayLogo from 'assets/logo.png';
import partner2kkLogo from 'assets/partners-logos/2kk-team.png';
import partnerLegionLogo from 'assets/partners-logos/legion-logo.png';
import partnerStormleadLogo from 'assets/partners-logos/stormlead-logo.png';

type Logo = {
  icon: string;
  width?: number;
  height?: number;
};

export const getCompanyLogo = (): Logo => {
  const hostname = window.location.hostname;
  switch (hostname) {
    case 'panel.2kk.team':
      return {
        icon: partner2kkLogo,
        height: 40,
      };
    case 'panel.stormlead.team':
      return {
        icon: partnerStormleadLogo,
        height: 20,
      };
    case 'panel.trafficlegion.team':
      return {
        icon: partnerLegionLogo,
        height: 26,
      };
    default:
      return {
        icon: adwayLogo,
        height: 20,
      };
  }
};
